import { RadioGroup } from "@mui/material";
import { Spacing } from "Infrastructure/Themes/Themes";
import type { ReactNode } from "react";
import { TypeTile } from "../TypeTile";

const COLUMNS = 4;

export type FormDrawerTile<TKey extends string> = {
  readonly key: TKey;
  readonly icon: ReactNode;
  readonly label: string;
  /** Every item of the tile, saved or not. */
  readonly count?: number;
  readonly hasError?: boolean;
};

type Props<TKey extends string> = {
  readonly tiles: FormDrawerTile<TKey>[];
  readonly activeKey: TKey;
  readonly onSelect: (key: TKey) => void;
  /** Names the group of tiles, e.g. "Typ příjmu". */
  readonly label: string;
};

// The tiles pick what the drawer shows, one at a time: a radio group of TypeTiles, each with the count of its items,
// or an error mark, which wins, as does the red border.
export const FormDrawerTiles = <TKey extends string>({ tiles, activeKey, onSelect, label }: Props<TKey>) => (
  <RadioGroup
    aria-label={label}
    value={activeKey}
    onChange={(_, value) => onSelect(value as TKey)}
    sx={{ display: "grid", gridTemplateColumns: `repeat(${COLUMNS}, minmax(0, 1fr))`, gap: Spacing.M }}
  >
    {tiles.map(({ key, icon, label: tileLabel, count = 0, hasError = false }) => (
      <TypeTile key={key} value={key} icon={icon} label={tileLabel} count={count} isActive={key === activeKey} error={hasError} />
    ))}
  </RadioGroup>
);
